import {
  getRelativeFontSize,
  mediumFont,
  regularFont,
  theme,
} from "../../utils/styles";

const settingsStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    mx: 5,
    [theme.breakpoints.down("sm")]: {
      mx: 2,
    },
  },
  mainBox: {
    p: 1,
    borderRadius: "20px",
    minHeight: "calc(100vh - 195px)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    margin: "25px 0px",
    maxWidth: "1750px",
    width: "100%",
  },
  subBox: {
    p: 3,
    minHeight: "calc(100vh - 235px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
  },
  settingSection: {
    background: "rgba(255, 255, 255, 0.05)",
    borderRadius: "10px",
    p: 3,
    mt: 2,
  },
  settingCard: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    p: 2,
    border: "1px solid rgba(255, 255, 255, 0.14)",
    borderRadius: "8px",
    background: "rgba(255, 255, 255, 0.02)",
  },
  settingLabel: {
    ...mediumFont,
    fontSize: getRelativeFontSize(4),
    color: "#FFF",
  },
  settingDescription: {
    ...regularFont,
    fontSize: getRelativeFontSize(2),
    color: "rgba(255, 255, 255, 0.7)",
    mb: 2,
  },
  settingValue: {
    ...mediumFont,
    fontSize: getRelativeFontSize(3),
    color: "#9F3AFF",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 1,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  settingIcon: {
    width: "24px",
    height: "24px",
    color: "rgba(255, 255, 255, 0.7)",
  },
  italicTypo: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "45px",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.77px",
    textTransform: "uppercase",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "35px",
    },
  },
} as const;

export default settingsStyles;
